import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { IoClose } from 'react-icons/io5';
import { toast } from 'react-toastify';
import { API } from '../config';


export default function RecoveryEmail({ show, onClose, token }) {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (show) {
            setEmail('');
        }
    }, [show]);

    if (!show) return null;

  const handleSubmit = async e => {
    e.preventDefault();
    if (!email) {
      return toast.error('Please fill in your recovery email.');
    }

    setSubmitting(true);
    try {
      //console.log('Auth token:', token);
      await axios.post(
        `${API}/api/users/recovery-email`,
        { email: email.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Recovery email set! You can now use it to recover your password.');
      onClose();
      // clear fields
        setEmail('');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Could not set recovery email. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className='change-password'>
        <div className="overlay">
              <form onSubmit={handleSubmit} className="pwd-form">
                <IoClose className="close-icon" onClick={onClose}/>
              
                <div className="form-input">
                      <label htmlFor="email">
                          Enter your recovery email
                      </label>
                      <input
                        name='email'
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                      />
                </div>
                

                <button type="submit" className="btn" id='feedback-button' disabled={submitting}>
                    <span className="btn-text">{submitting ? 'Submitting…' : 'Submit'}</span>
                </button>
              </form>
        </div>
    </section>

  );
}
